import { Box, Grid, Tooltip, Typography } from '@mui/material';
import { TextWithLimitedWidth } from 'components/SlideGroups/components/TextWithLimitedWidth';
import React from 'react';
import { Link } from 'react-router-dom';
import { getStatusComponent } from 'components/TeamOverview/components/AiComputeTransactionsCard/utilities';
import { SourceTitle } from 'components/TeamOverview/components/AiComputeTransactionsCard/components/SourceTitle';

export const DataRow = ({
  sourceUrl,
  slideViewerUrl,
  orderName,
  slideName,
  toolType,
  cost,
  statusGroup,
  processedOnDate,
  processingDetails,
  classes,
}) => (
  <Grid container className={classes.row}>
    <Grid item xs={1.5}>
      <SourceTitle
        orderName={orderName}
        sourceUrl={sourceUrl}
        classes={classes}
      />
    </Grid>
    <Tooltip title={`${orderName} / ${slideName}`} placement="top">
      <Grid item xs={4} paddingRight="0.5rem">
        <TextWithLimitedWidth value={slideName} textClass={classes.boldLabel} />
      </Grid>
    </Tooltip>
    <Grid item xs={2}>
      <Tooltip title={toolType.long} placement="left">
        <Box display="flex" alignItems={'center'}>
          <Box className={classes.sourceLinkIcon}>
            <img
              alt="logo"
              src={toolType.logo}
              className={classes.serviceLogo}
            />
          </Box>
          <Link className={classes.link} to={toolType.app_url}>
            {toolType.short}
          </Link>
        </Box>
      </Tooltip>
    </Grid>
    <Grid item xs={1}>
      <Typography className={classes.defaultLabel}>${cost}</Typography>
    </Grid>
    <Grid item xs={2}>
      {getStatusComponent(classes, statusGroup, slideViewerUrl)}
    </Grid>
    <Grid item xs={1.5}>
      <Tooltip title={processingDetails} placement="left">
        <Typography className={classes.defaultLabel}>
          {processedOnDate}
        </Typography>
      </Tooltip>
    </Grid>
  </Grid>
);
